import * as React from 'react';
import Wrapper, {InputVariant} from 'components/Input';
import {InputProps, Word} from './types';

/**
 * The group input.
 * @param {InputProps} props
 * @return {React.ReactElement<InputProps>}
 * @constructor
 */
export default function Input(
  {
    onCreated,
    ...otherProps
  }: InputProps,
): React.ReactElement<InputProps> {
  const [
    word, setWord,
  ] = React.useState<Word>('');

  /**
   * The change event handler.
   * @param {React.ChangeEvent<HTMLInputElement>} event
   * @return {void}
   */
  function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
    setWord(event.target.value);
  }

  /**
   * The key press event handler.
   * @param {React.MouseEvent<KeyboardEvent>} event
   * @return {void}
   */
  function handleKeyPress(
    event: React.KeyboardEvent<HTMLInputElement>,
  ): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      onCreated && onCreated(word);
      setWord('');
    }
  }

  return (
    <Wrapper
      {...otherProps}
      value={word}
      variant={InputVariant.Accent}
      placeholder="Введите и нажмите Enter"
      onChange={handleChange}
      onKeyPress={handleKeyPress}
    />
  );
}
